<template>
  <div v-if="!hidden" class="mb-4">
    <b-button block variant="dark" @click.prevent="collapsed = !collapsed">
      Toggle debug panel
    </b-button>
    <b-card v-if="!collapsed" class="mb-0">
      <pre class="mb-0"><slot /></pre>
    </b-card>
  </div>
</template>
<script>
import env from 'environment';

export default {
  props: {
    hidden: {
      type: Boolean,
      default: env.production
    }
  },

  data() {
    return {
      collapsed: true
    };
  }
}
</script>
